export default "__VITE_ASSET__4fca1687__"